/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CurrencyType {
    EUR = 'EUR',
    GBP = 'GBP',
    USD = 'USD',
    DKK = 'DKK',
    NOK = 'NOK',
    PLN = 'PLN',
    SEK = 'SEK',
    CHF = 'CHF',
    DZD = 'DZD',
    ARS = 'ARS',
    AMD = 'AMD',
    AWG = 'AWG',
    AUD = 'AUD',
    AZN = 'AZN',
    BSD = 'BSD',
    BHD = 'BHD',
    THB = 'THB',
    PAB = 'PAB',
    BBD = 'BBD',
    BYN = 'BYN',
    BZD = 'BZD',
    BMD = 'BMD',
    VES = 'VES',
    VED = 'VED',
    BOB = 'BOB',
    BRL = 'BRL',
    BND = 'BND',
    BGN = 'BGN',
    BIF = 'BIF',
    CVE = 'CVE',
    CAD = 'CAD',
    KYD = 'KYD',
    XOF = 'XOF',
    XAF = 'XAF',
    XPF = 'XPF',
    CLP = 'CLP',
    COP = 'COP',
    KMF = 'KMF',
    CDF = 'CDF',
    BAM = 'BAM',
    NIO = 'NIO',
    CRC = 'CRC',
    CUP = 'CUP',
    CZK = 'CZK',
    GMD = 'GMD',
    MKD = 'MKD',
    DJF = 'DJF',
    STN = 'STN',
    DOP = 'DOP',
    VND = 'VND',
    XCD = 'XCD',
    EGP = 'EGP',
    SVC = 'SVC',
    ETB = 'ETB',
    FKP = 'FKP',
    FJD = 'FJD',
    HUF = 'HUF',
    GHS = 'GHS',
    GIP = 'GIP',
    HTG = 'HTG',
    PYG = 'PYG',
    GNF = 'GNF',
    GYD = 'GYD',
    HKD = 'HKD',
    UAH = 'UAH',
    ISK = 'ISK',
    INR = 'INR',
    IRR = 'IRR',
    IQD = 'IQD',
    JMD = 'JMD',
    JOD = 'JOD',
    KES = 'KES',
    PGK = 'PGK',
    KWD = 'KWD',
    AOA = 'AOA',
    MMK = 'MMK',
    LAK = 'LAK',
    GEL = 'GEL',
    LBP = 'LBP',
    ALL = 'ALL',
    HNL = 'HNL',
    SLE = 'SLE',
    LRD = 'LRD',
    LYD = 'LYD',
    SZL = 'SZL',
    LSL = 'LSL',
    MGA = 'MGA',
    MWK = 'MWK',
    MYR = 'MYR',
    MUR = 'MUR',
    MXN = 'MXN',
    MDL = 'MDL',
    MAD = 'MAD',
    MZN = 'MZN',
    NGN = 'NGN',
    ERN = 'ERN',
    NAD = 'NAD',
    NPR = 'NPR',
    ANG = 'ANG',
    ILS = 'ILS',
    TWD = 'TWD',
    NZD = 'NZD',
    BTN = 'BTN',
    KPW = 'KPW',
    MRU = 'MRU',
    TOP = 'TOP',
    PKR = 'PKR',
    MOP = 'MOP',
    CUC = 'CUC',
    UYU = 'UYU',
    PHP = 'PHP',
    BWP = 'BWP',
    QAR = 'QAR',
    GTQ = 'GTQ',
    ZAR = 'ZAR',
    OMR = 'OMR',
    KHR = 'KHR',
    RON = 'RON',
    MVR = 'MVR',
    IDR = 'IDR',
    RUB = 'RUB',
    RWF = 'RWF',
    SHP = 'SHP',
    SAR = 'SAR',
    RSD = 'RSD',
    SCR = 'SCR',
    SGD = 'SGD',
    PEN = 'PEN',
    SBD = 'SBD',
    KGS = 'KGS',
    SOS = 'SOS',
    TJS = 'TJS',
    SSP = 'SSP',
    LKR = 'LKR',
    XSU = 'XSU',
    SDG = 'SDG',
    SRD = 'SRD',
    SYP = 'SYP',
    BDT = 'BDT',
    WST = 'WST',
    TZS = 'TZS',
    KZT = 'KZT',
    TTD = 'TTD',
    MNT = 'MNT',
    TND = 'TND',
    TRY = 'TRY',
    TMT = 'TMT',
    AED = 'AED',
    UGX = 'UGX',
    UZS = 'UZS',
    VUV = 'VUV',
    KRW = 'KRW',
    YER = 'YER',
    JPY = 'JPY',
    CNY = 'CNY',
    ZMW = 'ZMW',
    ZWL = 'ZWL',
}
